export default __webpack_public_path__ + "static/media/SN.aed5f269.svg";